import { render } from "./ListCurrencies.vue?vue&type=template&id=a57d8f80&ts=true"
import script from "./ListCurrencies.vue?vue&type=script&lang=ts"
export * from "./ListCurrencies.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__